import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';
import { INotification } from './interfaces';

export const getNotificationList = (config?: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get<{ list: INotification[]; totalCount: number }>(`/notification/list`, config)
    .then((response) => response.data);
};

export const readNotifications = (notificationIds: number[]) => {
  return instance(true, PPR_API_URL)
    .post('/notification/updateView', { notificationIds })
    .then((response) => response.data);
};

export const deleteNotifications = (notificationIds: number[]) => {
  return instance(true, PPR_API_URL)
    .post('/notification/delete', { notificationIds })
    .then((response) => response.data);
};

export const deleteAllNotifications = () => {
  return instance(true, PPR_API_URL)
    .post('/notification/deleteAll')
    .then((response) => response.data);
};

export const readAllNotifications = () => {
  return instance(true, PPR_API_URL)
    .post('/notification/updateViewAll')
    .then((response) => response.data);
};

export const hasNotificationsPpr = () => {
  return instance(true, PPR_API_URL)
    .get<{ hasNotView: boolean }>('/notification/hasNotView')
    .then((response) => response.data);
};
